export default "__VITE_ASSET__a516fb0e__"